import { render, staticRenderFns } from "./BalanceSettingsModal.vue?vue&type=template&id=2c5c8518&scoped=true&"
import script from "./BalanceSettingsModal.vue?vue&type=script&lang=js&"
export * from "./BalanceSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./BalanceSettingsModal.vue?vue&type=style&index=0&id=2c5c8518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c8518",
  null
  
)

export default component.exports